function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.424 19l.001 1.296c0 .149.134.283.289.283L7 20.578V22h2v-1.422h2V22h2v-1.422h2V22h2v-1.422h1.525L18.536 19h1.472l-.004 1.529a1.48 1.48 0 01-1.337 1.468l-.142.007V22l-12.811.004A1.718 1.718 0 014 20.296V19h1.424zm6.356-3a.75.75 0 110 1.5H7.75a.75.75 0 110-1.5h4.03zm8.24-1l-.006 2h-1.465l.014-2h1.457zm-3.853-2c.414 0 .85.336.85.75s-.436.75-.85.75H7.75a.75.75 0 110-1.5h8.417zm3.865-2l-.006 2h-1.449l.014-2h1.441zm-3.745-1a.75.75 0 110 1.5H7.75a.75.75 0 110-1.5h8.537zm-.862-6.445v2.447h2.417l-2.417-2.447zM4 15h1.424v2H4v-2zm0-4h1.424v2H4v-2zm0-4h1.424v2H4V7zm11.594-5c.19 0 .373.076.507.212l3.74 3.785a.713.713 0 01.205.5L20.038 9h-1.434l.012-1.573H15a1 1 0 01-1-1V3.424h-1V2h2.594zM11 2v1.424H9V2h2zM4 3.707C4 2.761 4.763 2 5.717 2H7v1.424l-1.283.001a.281.281 0 00-.292.282L5.424 5H4V3.707z",
  fill: "#FF9E01",
  fillRule: "nonzero"
});
function SvgIncompleteCons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "1 2 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteCons);
export default __webpack_public_path__ + "static/media/incomplete_cons.d4323d08.svg";
export { ForwardRef as ReactComponent };